import { useState } from 'react';
import { useSelector } from 'src/hooks/useSelector';
import SocialShareLinks from 'src/utils/SocialShareLinks';
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedin,
  FaEnvelope,
  FaCopy,
  FaCheck,
} from 'react-icons/fa';

const Social = ({ event, align, extraClasses }) => {
  const [justCopied, setJustCopied] = useState(false);
  const publisherSettings = useSelector((state) => state.publisherSettings);

  const links = new SocialShareLinks(event, publisherSettings);

  let alignClasses = 'justify-end @md:justify-start';
  if (align === 'right') {
    alignClasses = 'justify-end';
  }

  const openLink = (url) => {
    const defaultOptions = {
      width: 500,
      height: 500,
    };

    const px = Math.floor(((window.screen.availWidth || 1024) - defaultOptions.width) / 2),
      py = Math.floor(((window.screen.availHeight || 700) - defaultOptions.height) / 2);

    const popup = window.open(
      url,
      'social',
      'width=' +
        defaultOptions.width +
        ',height=' +
        defaultOptions.height +
        ',left=' +
        px +
        ',top=' +
        py +
        ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1'
    );
  };

  const copyLink = () => {
    const el = document.createElement('textarea');
    el.value = event.absoluteHref;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    setJustCopied(true);
    setTimeout(() => setJustCopied(false), 1000);
  };

  return (
    <div
      className={`flex flex-row w-full ${alignClasses} text-gray-600 mt-4 @sm:ml-2 mb-4 pr-2 ${extraClasses}`}
    >
      <FaTwitter onClick={() => openLink(links.twitterURL)} className="mx-2 cursor-pointer" />
      <FaFacebookF
        onClick={() => openLink(links.facebookURL)}
        className="mx-2 cursor-pointer"
      />
      <FaLinkedin
        onClick={() => openLink(links.linkedInURL)}
        className="mx-2 cursor-pointer"
      />
      <a
        href={`mailto:?subject=${event.title}&body=${event.absoluteHref}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaEnvelope onClick={() => openEmail()} className="mx-2 cursor-pointer" />
      </a>
      {justCopied && <FaCheck className="mx-2 ml-3 text-green-500" />}
      {!justCopied && (
        <FaCopy onClick={() => copyLink()} className="mx-2 ml-3 cursor-pointer" />
      )}
    </div>
  );
};

export default Social;
